"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    code: function (_a) {
        var theme = _a.theme, color = _a.color;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { lineHeight: theme.lineHeight, padding: [1, theme.spacing.xs / 2], borderRadius: theme.radius.sm, color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 1 : 9 }), backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 9 : 0 }), fontFamily: theme.fontFamilyMonospace, fontSize: theme.fontSizes.xs, border: "1px solid " + theme_1.getThemeColor({
                theme: theme,
                color: color,
                shade: theme.colorScheme === 'dark' ? 9 : 3,
            }) }));
    },
    pre: function (_a) {
        var theme = _a.theme;
        return ({
            padding: theme.spacing.xs,
            margin: 0,
            overflowX: 'auto',
        });
    },
}, { link: true });
